const zh = {
  header: {
    tip1:
      "为了防止系统误关闭您的虚拟空间中正在进行的游戏，导致您的游戏在未知情况下被掉线中断，需要您手动按照以下步骤完成设置。",
  },
  content: {
    list1: {
      title: "多进程管理状态时，将虚拟大师添加【锁定】，保持后台可运行。",
    },
    list2: {
      title: "打开手机管家，找到应用管理。",
    },
    list3: {
      title: "搜索虚拟大师，找到省电策略，设置【无限制】。",
    },
  },
};

export default zh;
